const standardFeudItemsData = [
	{
		"name" : "Main Event Ready",
		"description" : "Two superstars on the cusp of the main event fight to see who is deserving of it.",
		"baseHype" : 20,
		"consequence" : "main-event-push",
		"oneAtATime" : false,
		"requirement" : "upper-midcarders",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Stepping Up",
		"description" : "A low-on-the-card superstar looks to step up in the roster.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "lower-vs-upper-midcarder",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Who's the Best?",
		"description" : "Tag partners fight to see which one is the better member of the team.",
		"baseHype" : 15,
		"consequence" : "disband-tag-team",
		"oneAtATime" : false,
		"requirement" : "tag-partners",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Ungrateful",
		"description" : "A hard-working superstars looks to teach an unhappy one a lesson.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "unhappy-vs-happy",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Better Wrestler",
		"description" : null,
		"baseHype" : 5,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : null,
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "End the Reign",
		"description" : "A challenger emerges, promising to end a long title reign.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "long-title-reign",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "I'm the Next Face",
		"description" : "Two emerging stars confront each other to see who can get to the top first.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "becoming-fotc",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "That's My Shot",
		"description" : "A contender challenges a match contract holder, claiming the contract as theirs.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "match-contract-won",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "End the Streak",
		"description" : "A contender believes they can be the one to end a long winning streak.",
		"baseHype" : 30,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "long-streak",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Injury Revenge",
		"description" : "A returning superstar is looking to make the person who injured them pay.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "injury-return",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Streak Revenge",
		"description" : "The former streak holder comes for retribution.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "streak-broken",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "No More Jokes",
		"description" : "A harmless rib gets out of hand and becomes the basis for a feud.",
		"baseHype" : 10,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "rib",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "New Challenger",
		"description" : "A new challenger emerges for the championship.",
		"baseHype" : 10,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "new-title-challenger",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Leave For Good",
		"description" : "A superstar or tag team forced to leave the company return to get even.",
		"baseHype" : 25,
		"consequence" : "fired",
		"oneAtATime" : false,
		"requirement" : "loser-leaves",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Us vs Them",
		"description" : "A superstar fights for his locker room against another company's talent.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "trade-deal",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Are You Proud?",
		"description" : "A friend of a retired superstar is unhappy with the person who retired them.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "career-ended",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Taking My Spot",
		"description" : "A full-timer refuses to let a part-timer take their spot.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "part-timer-vs-full-timer",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Fall From Grace",
		"description" : "A superstar looks to regain the popularity they lost while another looks to put them further down the card.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "large-popularity-loss",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "It's My Time Now",
		"description" : "A young superstar wants to take the spot of an older one.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "young-vs-old",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Better Champion",
		"description" : "Two champions fight it out to see which champion is the better one.",
		"baseHype" : 25,
		"consequence" : "unify-titles",
		"oneAtATime" : false,
		"requirement" : "champions",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "This Is Our Home",
		"description" : "A mainstay of the roster clashes with a new indie signing.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "indie-superstar",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Selling Out",
		"description" : "A superstar betrays their tag partner to move on to bigger things.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "disbanded-tag-team",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Grudge",
		"description" : null,
		"baseHype" : 5,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : null,
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Disrespect",
		"description" : null,
		"baseHype" : 5,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : null,
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Friendly Contest",
		"description" : "Two faces fight each other to see who is better.",
		"baseHype" : 10,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "face-vs-face",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Rivals",
		"description" : "Two rivals with a history of great feuds go to battle again.",
		"baseHype" : 10,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "previous-feuds",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Prove Yourself",
		"description" : "A new tag team looks to prove its effectiveness against an established team.",
		"baseHype" : 10,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "new-tag-team",
		"category" : null,
		"unlocked" : true,
		"singles" : false,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Career vs Career",
		"description" : "Two aging superstars put their careers on the line to see which one retires.",
		"baseHype" : 30,
		"consequence" : "retirement",
		"oneAtATime" : true,
		"requirement" : "retiring-superstars",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Jealous Friend",
		"description" : "A tag partner is jealous of their friend's success.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "disbanded-tag-team",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Not Done Yet",
		"description" : "A retired superstar comes back to get revenge on the person who retired them.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "retirement-feud",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Retire Me",
		"description" : "An aging superstar looks for the right superstar to retire them.",
		"baseHype" : 25,
		"consequence" : "retirement",
		"oneAtATime" : true,
		"requirement" : "retiring-superstar",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : false
	},
	{
		"name" : "Streak vs Career",
		"description" : "A superstars puts their career on the line to end a long winning streak.",
		"baseHype" : 35,
		"consequence" : "retirement",
		"oneAtATime" : true,
		"requirement" : "old-and-long-streak",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : false
	},
	{
		"name" : "Last Shot",
		"description" : "A challenger is willing to do whatever it takes for one final shot at the title.",
		"baseHype" : 20,
		"consequence" : "unavailable",
		"oneAtATime" : false,
		"requirement" : "previous-title-feud",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : false
	},
	{
		"name" : "Legend Killer",
		"description" : "A hungry superstar looks to take out a hall-of-famer returning from retirement.",
		"baseHype" : 20,
		"consequence" : "unavailable",
		"oneAtATime" : false,
		"requirement" : "hall-of-famer-return",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : false
	},
	{
		"name" : "All or Nothing",
		"description" : "A challenger puts their career on the line in order to be the champion.",
		"baseHype" : 30,
		"consequence" : "retirement",
		"oneAtATime" : true,
		"requirement" : "old-and-champion",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : false
	},
	{
		"name" : "That's My Title",
		"description" : "A previous title holder wants back the title that once belonged to them.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "previous-champion",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Innovation",
		"description" : "Two tag teams explore new territory in order to outdo each other.",
		"baseHype" : 20,
		"consequence" : "new-gimmick-match",
		"oneAtATime" : true,
		"requirement" : "young-midcarders",
		"category" : null,
		"unlocked" : false,
		"singles" : false,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Best in the World",
		"description" : "Two faces of the company challenge each other to see who is the best.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "faces-of-the-company",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Corruption",
		"description" : "A face is tempted by a heel towards corruption.",
		"baseHype" : 15,
		"consequence" : "loser-turns-heel",
		"oneAtATime" : false,
		"requirement" : "face-vs-heel",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : true
	},
	{
		"name" : "Redemption",
		"description" : "A heel battles a face in the aim of redemption.",
		"baseHype" : 15,
		"consequence" : "winner-turns-face",
		"oneAtATime" : false,
		"requirement" : "face-vs-heel",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : true,
		"faction" : true
	},
	{
		"name" : "Better Villain",
		"description" : "Two heels fight each other to see who is more dominant.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "heel-vs-heel",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Betrayal",
		"description" : "Former partners fight each other after a sudden betrayal.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "backstab",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Becoming Good",
		"description" : "A newly-turned face looks to get over their heel partner.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "defying-a-villain",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Vengeance",
		"description" : "A newly-turned heel looks to enact vengance.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "delayed-vengeance",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Greatest Wrestler",
		"description" : "Two superstars renowned for their wrestling ability fight to see who is the greatest.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "high-workrate",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Fighting the Darkness",
		"description" : "A face tries to fight off a newly-turned heel.",
		"baseHype" : 15,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "vicious-beatdown",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Bitter Rivals",
		"description" : "A hot feud is rekindled as two bitter rivals fight again.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "previous-hot-feud",
		"category" : null,
		"unlocked" : false,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Only Monster",
		"description" : "Two over heels fight to see who is the only true monster in the company.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "heel-vs-heel-hot",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Top Talent",
		"description" : "Two over faces fight to determine the top talent in the company.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "face-vs-face-hot",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "This is Personal",
		"description" : "Two superstars look to settle their personal history.",
		"baseHype" : 30,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "backstage-fight",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Mask vs Career",
		"description" : "A superstars puts their career on the line against the mask of another.",
		"baseHype" : 30,
		"consequence" : "retirement-or-unmasking",
		"oneAtATime" : true,
		"requirement" : "old-and-mask",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Not Your Place",
		"description" : "Faction members fight to see who leaves the faction.",
		"baseHype" : 20,
		"consequence" : "leave-faction",
		"oneAtATime" : true,
		"requirement" : "faction-members",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "True Leader",
		"description" : "A faction member fights the leader for the right to lead the faction.",
		"baseHype" : 20,
		"consequence" : "become-faction-leader",
		"oneAtATime" : true,
		"requirement" : "faction-leader-present",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Best Among Us",
		"description" : "Faction members fight to see who will lead the faction.",
		"baseHype" : 20,
		"consequence" : "become-faction-leader",
		"oneAtATime" : true,
		"requirement" : "no-faction-leader",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Headhunting",
		"description" : "A faction leader looks to recruit a superstar into their faction.",
		"baseHype" : 20,
		"consequence" : "join-faction",
		"oneAtATime" : true,
		"requirement" : "faction-present",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Civil War",
		"description" : "A faction splits off from within another and starts a war against them.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "internal-division",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Leader Revenge",
		"description" : "A former faction leader looks for revenge against the person who usurped them.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "usurped",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Treachery",
		"description" : "A superstar betrays their faction to join another.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "switching-sides",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Total War",
		"description" : "Factions go to war against another to see who is the top power in the company.",
		"baseHype" : 30,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "faction-vs-faction-hot",
		"category" : null,
		"unlocked" : true,
		"singles" : false,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "End of the Line",
		"description" : "Two factions fight to put an end to each other.",
		"baseHype" : 25,
		"consequence" : "disband-faction",
		"oneAtATime" : true,
		"requirement" : null,
		"category" : null,
		"unlocked" : true,
		"singles" : false,
		"tag" : false,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "Former Manager",
		"description" : "A superstar seeks revenge for their manager's betrayal.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "client-betrayal",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "True Loyalties",
		"description" : "Two clients belonging to the same manager fight each other.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "same-manager",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : false
	},
	{
		"name" : "Brand Loyalty",
		"description" : "Superstars belonging to different brands fight to see which brand is superior.",
		"baseHype" : 20,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "different-brands",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : true,
		"directFeud" : false,
		"oneWayConsequence" : false,
		"faction" : true
	},
	{
		"name" : "I Can Still Go",
		"description" : "A superstar tries to prove they still have it.",
		"baseHype" : 25,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "retirement-fakeout",
		"category" : null,
		"unlocked" : true,
		"singles" : true,
		"tag" : false,
		"directFeud" : true,
		"oneWayConsequence" : false,
		"faction" : false
	}
];

export {standardFeudItemsData}
